module.exports = require("cloudinary-core");


//////////////////
// WEBPACK FOOTER
// external "cloudinary-core"
// module id = 181
// module chunks = 0